import api from '../../utils/apiFetch';

const path = 'catalog';
export default {
  getCategories: (typeId) => api.get(`${path}/categories?type=${typeId}`),
};
